import { FilterOperatorEnum } from '@/shared/types/types.generated';

export const isRootFilter = (filter: any, fieldName: string) =>
  filter?.[fieldName]?.eq === null &&
  filter?.[fieldName]?.doNotIgnoreNullable?.includes(FilterOperatorEnum.Eq);

export const createEntityTagProviders = <T>(
  entityType: T,
  idField: string,
  parentField: string,
) => ({
  listTags: (result: any, error: any, arg: any) => {
    const fieldName = `readAll${entityType}`;
    const tags: Array<{ type: T; id: string }> = [
      { type: entityType, id: 'LIST' },
    ];
    if (isRootFilter(arg?.filter, parentField)) {
      tags.push({ type: entityType, id: 'ROOT' });
    }
    if (
      arg?.filter?.[parentField]?.eq &&
      arg?.filter?.[parentField].eq !== null
    ) {
      tags.push({
        type: entityType,
        id: `parent-${arg.filter[parentField].eq}`,
      });
    }
    if (result?.[fieldName]?.items) {
      result[fieldName].items.forEach((item: any) => {
        tags.push({ type: entityType, id: item[idField] });
      });
    }

    return tags;
  },
});
